// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"72df739d","455":"02f67849","497":"b253c83d","977":"f71b7a63"}[chunkId] + ".chunk.js";
};